/**
 * Created by asiulik on 08.05.2017.
 */
define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../utils'], function($, _, EventEmitter, Utils) {

    var changeHeaderBackgroundOffset = 5;
    var $window = $(window);
    var $body = $('body');
    var $header = $('#p__header');

    var OVERLAY_OPEN_CLASS = "overlay--open";
    var OVERLAY_GLOBAL_CLOSE_SELECTOR = '[data-overlay-close]';
    var OVERLAY_GLOBAL_TRIGGER = 'data-trigger-overlay';

    function Overlay(){
    }

    Overlay.prototype = _.clone(EventEmitter.prototype);

    Overlay.prototype.getStatus = function(){

        return this.overlay;

    };

    Overlay.prototype.getOverlay = function(){

        return this.overlay;

    };

    Overlay.prototype.init = function(){

        this.bindEvents();

    };

    Overlay.prototype.openOverlay = function(overlay){

        if(this.overlay) this.hideOverlay();

        this.overlay = overlay;
        this.prepareOverlay();
        this.overlay.addClass(OVERLAY_OPEN_CLASS);

        $body.addClass('body--overlay');

        this.updateDetailClasses('addClass');

        this.emit('openOverlay', overlay);

        return this.overlayStatus;

    };

    Overlay.prototype.prepareOverlay = function(){

        var container = this.overlay;

        Utils.scrollPositionAnimate(0, 1, this.overlay);

        container.on('scroll.overlayNamespace', function(){

            var scrollTopOffset = container.scrollTop();

            scrollTopOffset > changeHeaderBackgroundOffset ?
                $header.addClass('overlay__header__background') :
                $header.removeClass('overlay__header__background');

        });

    };

    Overlay.prototype.updateDetailClasses = function(action){

        $body[action](getOverlayInstaceClasses(this.overlay, 'overlayBodyClasses'));
        $header[action](getOverlayInstaceClasses(this.overlay, 'overlayHeaderClasses'));

    };

    Overlay.prototype.hideOverlay = function(){
        if (this.overlay) {
            this.overlay.off('scroll.overlayNamespace');
            this.overlay.removeClass(OVERLAY_OPEN_CLASS);
            $header.removeClass('overlay__header__background');
        }

        $body.removeClass('body--overlay');

        this.updateDetailClasses('removeClass');
        this.emit('hideOverlay', this.overlay);

        this.overlay = undefined;

    };

    Overlay.prototype.hideOverlayOnCondition = function($overlayElement){

        var currentOverlay = this.getOverlay();
        if(!currentOverlay) return;
        if(currentOverlay == $overlayElement){
            this.hideOverlay();
        }

    };

    Overlay.prototype.bindEvents = function(){

        var _this = this;

        $(document).on({
            keyup: function(e) {
                if (e.keyCode === 27) _this.hideOverlay();
            }
        });

        $(document).on({
            click: function(e) {
                _this.hideOverlay();
            }
        }, OVERLAY_GLOBAL_CLOSE_SELECTOR);


        $(document).on({
            click: function(e) {

                var $this = $(this);
                var $overlay = $($this.attr(OVERLAY_GLOBAL_TRIGGER));

                if($overlay && $overlay.length) {
                    _this.openOverlay($overlay);
                }

            }
        }, '[' + OVERLAY_GLOBAL_TRIGGER + ']');

        $(document).on({
            click: function(e) {
                _this.hideOverlay();
            }
        }, '.overlay__backdrop');

    };

    function getOverlayInstaceClasses(overlay, dataName) {
        if (overlay)
            return overlay.data(dataName);
        return null;
    }

    return Overlay;

});



// WEBPACK FOOTER //
// ./Private/Scripts/core/overlay.js